import { LINKS_ROUTES } from '../constants/routes';
import { DEPARTMENT } from '../constants/enums';

/**
 * QR & Links is for Marketing and Executive (Phase 2 section 9, U09).
 * `hasRouteAccess` short-circuits for Executive; it is listed anyway so the
 * rule reads the same as the server's `require_link_access`.
 */
const LINKS_RULE = Object.freeze({
  departments: [DEPARTMENT.MARKETING, DEPARTMENT.EXECUTIVE],
  roles: [],
});

export const LINKS_ROUTE_ACCESS = Object.freeze(
  Object.fromEntries(Object.values(LINKS_ROUTES).map((path) => [path, LINKS_RULE]))
);

export const LINKS_BUTTON_PERMISSIONS = Object.freeze({});

/** Links feature access — registered in configs/featureAccess. */
export const linksAccess = {
  id: 'links',
  routes: LINKS_ROUTE_ACCESS,
  buttons: LINKS_BUTTON_PERMISSIONS,
};
